import React from 'react';
import * as Icons from '@ant-design/icons';

const defaultSearchParams = (limit = true, page = true, sort = true, order = true) => {
    return {
        ...{},
        ...(limit ? { limit: '10' } : {}),
        ...(page ? { page: '1' } : {}),
        ...(sort ? { sort: 'created_at' } : {}),
        ...(order ? { order: 'desc' } : {})
    };
};

export const brands = (match) => [
    {
        icon: <Icons.SecurityScanOutlined />,
        text: 'Products',
        key: 'products-v2',
        menuTab: 'products',
        link: `${match.path}/review/products/in-review`
    },
    {
        link: `${match.path}/creative-settings?${new URLSearchParams(
            defaultSearchParams(true, true, false, false)
        ).toString()}`,
        icon: <Icons.BgColorsOutlined />,
        text: 'Creative settings',
        key: 'creative-settings-v2',
        menuTab: 'creative-settings'
    },
    {
        link: `${match.path}/accounts?${new URLSearchParams(defaultSearchParams()).toString()}`,
        icon: <Icons.ReconciliationOutlined />,
        text: 'Accounts',
        key: 'accounts-v2',
        menuTab: 'accounts'
    },
    {
        link: `${match.path}/brief`,
        icon: <Icons.AuditOutlined />,
        text: 'Brief',
        key: 'brief-v2',
        menuTab: 'brief'
    },
    {
        icon: <Icons.ShopOutlined />,
        text: 'Orders',
        key: 'orders-v2',
        menuTab: 'orders',
        link: `${match.path}/orders?${new URLSearchParams(defaultSearchParams()).toString()}`
    },
    {
        link: `${match.path}/privacy`,
        icon: <Icons.LockOutlined />,
        text: 'Customer privacy',
        key: 'privacy-v2',
        menuTab: 'privacy'
    },
    {
        icon: <Icons.SecurityScanOutlined />,
        text: 'Custom Creatives',
        key: 'custom-creatives-v2',
        menuTab: 'custom-creatives',
        link: `${match.path}/custom-creatives/in-review`
    },
    {
        link: `${match.path}/uplift-studies?${new URLSearchParams(defaultSearchParams()).toString()}`,
        icon: <Icons.ExperimentOutlined />,
        text: 'Uplift Studies',
        key: 'uplift-studies-v2',
        menuTab: 'uplift-studies'
    },
    ...(process.env.REACT_APP_FRONT_BUILD_ENV !== 'production' && process.env.REACT_APP_FRONT_BUILD_ENV !== 'rc'
        ? [
              {
                  link: `${match.path}/awa-explorer`,
                  icon: <Icons.PictureOutlined />,
                  text: 'AWA Explorer',
                  key: 'awa-explorer-v2',
                  menuTab: 'awa-explorer'
              }
          ]
        : [])
    // CP2 (cpv2-orders) moved to the System section — see config/menus/pages/system.js.
];
